import React from "react";
import { Box, Container, Grid, Typography, Button } from "@mui/material";
import guardImage5 from "../assets/backcompsee.jpg";
import guardImage10 from "../assets/walkitalki.jpg";

const googleFormLink = "https://forms.gle/UaBcErMPJHnr6gWr8";

const QuotePage = () => (
  <Box sx={{ backgroundColor: "#f4f4f4", paddingTop: "20px" }}>
    {/* Hero Section */}
    <Box
      sx={{
        backgroundImage: `url(${guardImage5})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#fff",
        textAlign: "center",
        padding: "80px 20px",
        position: "relative",
      }}
    >
      <Box
        sx={{ position: "absolute", inset: 0, bgcolor: "rgba(0,0,0,0.4)" }}
      />
      <Typography
        variant="h3"
        sx={{
          fontWeight: "bold",
          textTransform: "uppercase",
          position: "relative",
          zIndex: 1,
        }}
      >
        Request a Quote
      </Typography>
      <Typography
        variant="h6"
        sx={{ marginTop: "10px", position: "relative", zIndex: 1 }}
      >
        Need professional security services? Complete a quick request and our
        team will provide a tailored solution for your property or event.
      </Typography>
    </Box>

    {/* Image + Request Button Vertical Layout */}
    <Container sx={{ paddingY: "60px" }}>
      <Grid container spacing={4} direction="column" alignItems="center">
        {/* Image */}
        <Grid item xs={12} sx={{ width: "100%" }}>
          <Box
            component="img"
            src={guardImage10}
            alt="Professional Security Services"
            sx={{
              width: "100%",
              borderRadius: "8px",
              objectFit: "cover",
              boxShadow: 3,
            }}
          />
        </Grid>

        {/* Description */}
        <Grid item xs={12} sx={{ maxWidth: "800px", textAlign: "center" }}>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
            At LineGuard Security, we provide customized security solutions
            tailored to your needs. Whether protecting a residential property,
            commercial site, or managing an event, our team ensures reliable
            protection, quick response, and peace of mind. Request a quote today
            and let us design a security plan that safeguards your people,
            property, and assets efficiently and professionally.
          </Typography>
        </Grid>

        {/* Request Button */}
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            href={googleFormLink}
            target="_blank"
            sx={{
              padding: "18px 50px",
              fontSize: "1.2rem",
              borderRadius: "30px",
              textTransform: "none",
            }}
          >
            Request Your Services
          </Button>
        </Grid>
      </Grid>
    </Container>
  </Box>
);

export default QuotePage;
